import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import styles from './CampaignCard.module.scss'

const WidgetCampaignCard = ({ title, description, campaignName }) => {
  return (
    <Link className={styles.card} to={`editCampaign/sales/${campaignName}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </Link>
  )
}

WidgetCampaignCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(['dialog', 'snippet', 'exclude', 'promotion'])
}

export default WidgetCampaignCard
